import type { OrganizationAllowedBobcatTagDTO } from '@/api/trafikportalen';
import type { CollectionTypeDTO } from '@/api/trafikportalen/models/collectionTypeDTO';

export const hasRelationalProducts = (
  allowedTags: OrganizationAllowedBobcatTagDTO[],
  collectionType: CollectionTypeDTO,
): boolean =>
  allowedTags.some(
    (tag) =>
      tag.collection_type === collectionType && tag.tag_id.startsWith('pc_'),
  );

export const allOrganizationsHaveRelationalProducts = (
  allowedTagsByOrganization: OrganizationAllowedBobcatTagDTO[][],
  collectionType: CollectionTypeDTO,
): boolean =>
  allowedTagsByOrganization.length > 0 &&
  allowedTagsByOrganization.every((tags) =>
    hasRelationalProducts(tags, collectionType),
  );
